import { Currency } from '@/Domain/Batch/Currency'
import { SpeciesBinomen } from '@/Domain/Batch/Species'
import { OfferTarget } from './OfferTarget'

export class SpeciesOffer {
  private _globalAmount: Currency
  private _speciesBinomen: SpeciesBinomen
  private _offerTarget: OfferTarget
  private _internalId: number

  constructor (
    globalAmount: Currency,
    speciesBinomen: SpeciesBinomen,
    speciesInternalId: number,
    offerTarget: OfferTarget
  ) {
    this._globalAmount = globalAmount
    this._speciesBinomen = speciesBinomen
    this._offerTarget = offerTarget
    this._internalId = speciesInternalId
  }

  globalAmount (): string {
    return this._globalAmount.toString()
  }

  speciesBinomen (): string {
    return this._speciesBinomen.value()
  }

  offerTarget (): string {
    return this._offerTarget
  }

  internalId (): number {
    return this._internalId
  }
}
